import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Store } from '@ngrx/store'
import { AppState } from "../../reducers";
import { BoxOfficeActions } from "./ngrx/box-office.actions";
import {
	CategoryActions,
	EventActions,
	MessageActions,
	SeatingplanServerActions,
	TicketQuotaActions,
	VenueActions
} from "../../actions";
import { EventApi } from "../../services/webservice/event-api.service";
import { CategoryApi } from "../../services/webservice/category-api.service";
import { VenueApi } from "../../services/webservice/venue-api.service";
import { TicketQuotaApi } from "../../services/webservice/ticketquota-api.service";
import { MerchantApi, PriceLevelService, SeatingplanApi, TicketQuotaHandlingService } from "../../services";
import { TicketQuota } from "../../models";

@Injectable()
export class BoxOfficeResolver implements Resolve<void> {

	constructor(
		private store: Store<AppState>,
		private boxOfficeActions: BoxOfficeActions,
		private eventActions: EventActions,
		private venueActions: VenueActions,
		private categoryActions: CategoryActions,
		private ticketQuotaActions: TicketQuotaActions,
		private seatingplanServerActions: SeatingplanServerActions,
		private eventApi: EventApi,
		private categoryApi: CategoryApi,
		private venueApi: VenueApi,
		private ticketQuotaApi: TicketQuotaApi,
		private merchantApi: MerchantApi,
		private seatingPlanApi: SeatingplanApi,
		private priceLevelService: PriceLevelService,
		private messageActions: MessageActions,
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		// SHOPPINGCART
		this.store.select("shoppingCart", "shoppingCart")
			.filter((shoppingCart) => !!shoppingCart)
			.take(1)
			.subscribe(
				(shoppingCart) => {
				if (shoppingCart.ticketItems.length > 0) {
					/* remove Tickets from other Events */
					this.store.select("shoppingCart", "displayShoppingCart")
						.take(1)
						.subscribe(dsc => {
							const ticketItemsToBeDeleted = []
							if (dsc && dsc.events) {
								dsc.events
									.filter(event => event.eventId.toString() !== route.params["id"])
									.map(event => {
										if (event.displayTickets) {
											event.displayTickets
												.map(dspTickets =>
													dspTickets.ticketItemUuids
														.map(ticketItemUuid => ticketItemsToBeDeleted.push(ticketItemUuid)))
										}
									})
							}
							if (ticketItemsToBeDeleted.length > 0) {
								this.store.dispatch(this.boxOfficeActions.removeTicketsBoxOffice(shoppingCart._links.tickets.href, ticketItemsToBeDeleted))
								this.store.dispatch(this.messageActions.displayMessage("Tickets anderer Veranstaltungen wurden aus dem Warenkorb entfernt.", "success"))
							}
						})
				}
			});

		this.store.dispatch(this.boxOfficeActions.clearEventServerState())
		this.store.dispatch(this.venueActions.clearState())
		this.eventApi.getEventById(route.params["id"]).subscribe(event => {
			this.store.dispatch(this.eventActions.eventLoaded(event))
			this.venueApi.getVenueById(event.venueId.toString()).subscribe(venue => this.store.dispatch(this.venueActions.venueLoaded(venue)))
			this.categoryApi.getCategories(event._links.categories.href).subscribe(categories => {
				this.store.dispatch(this.categoryActions.loadCollectionSuccess(categories))
				this.priceLevelService.loadPriceLevels(categories)
			})
			if (route.data.boxOfficeSP) {
				this.seatingPlanApi.loadSeatingplanByUuid(event.seatingplanUuid).subscribe(seatingplan => {
					this.store.dispatch(this.seatingplanServerActions.seatingplanLoaded(seatingplan));
				});
			}
			this.ticketQuotaApi.getTicketQuotas(event._links.ticketQuotas.href)
				.subscribe((response) => {
					if (!response) {
						return;
					}
					// Filter by allowed BookingOffice
					response._embedded.ticketQuotas = response._embedded.ticketQuotas.filter((tq: TicketQuota) =>
						tq.allowedBookingOfficeUUIDs.indexOf(this.merchantApi.getBookingOfficeUuid()) > -1);
					this.store.dispatch(this.ticketQuotaActions.loadCollectionSuccess(response));
					return this.store.dispatch((this.boxOfficeActions.setSelectedTicketQuotaBoxOffice(
						route.queryParams['ticketQuotaId'] ?
							TicketQuotaHandlingService.getTicketQuota(response._embedded.ticketQuotas, Number(route.queryParams['ticketQuotaId'])) :
							TicketQuotaHandlingService.getStandardTicketQuotaOrFirstOrNull(response._embedded.ticketQuotas))
					));
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/components/box-office/box-office.resolver.ts